import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as MessageActions from '../../../actions/messages';
import MessageNotificationConstants from '../../../constants/messageNotificationConstants'

const Tab = (props) => {
  const {
    dispatch,
    active,
    id,
    children,
    name,
    to,
  } = props;

  const onSelect = props.location.pathname === MessageNotificationConstants.messagesPathName ? 
                                      () => { dispatch(MessageActions.clearNotification()) } : 
                                      props.onSelect;
                                      
  const activeLabel = (active === '/') ? '/' : active.replace('/', '');

  const tabClass = classnames({
    nav__item: true,
    active: (activeLabel === id),
    notifying: (to === MessageNotificationConstants.messagesLinkTo && props.messagesChanged)
  });

  return (
    <li
      className={tabClass}
      data-name={name}
      onClick={onSelect}
      role="presentation"
    >
      <Link
        className={classnames(
          onSelect && 'cursor-pointer',
        )}
        to={to}
      >
        {children}
      </Link>
    </li>
  );
};

Tab.propTypes = {
  id: PropTypes.string.isRequired,
  active: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
  to: PropTypes.string.isRequired,
};

Tab.defaultProps = {
  onSelect: () => {
  },
};
const mapStateToProps = ({
  messages: { isChanged },
}) => ({
  messagesChanged: isChanged
});

export default withRouter(connect(mapStateToProps)(Tab));
